<script>
    import Widget from './Widget';
    import MargettsApi from '../modules/margetts-api';

    export default {
        extends: Widget,
        data() {
            return {
                iteration: 0,
                isLoading: true,
                requestCount: 0,
                classes: '',
                textAreas: []
            }
        },

        created() {
            this.render();
            this.registerAsRefreshable();
        },

        methods: {
            render() {
                this.block();
                this.iteration += 1;

                if (this.isMissingRequiredParameters()) {
                    this.unblock();
                    return;
                }

                this.requestCount++;
                const thisRequestCount = this.requestCount;

                MargettsApi.get(this.endpoint, this.createQueryStringFromParameters(), response => {
                    if (this.requestCount !== thisRequestCount) {
                        return;
                    }

                    if ( ! response || ! response.result) {
                        return MargettsApi.throwNoResponseError();
                    }

                    if (response.result !== 'success') {
                        return this.throwApiError(response.messages);
                    }

                    const data = response.data;

                    this.update(data).then(() => {
                        this.classes = this.retrieveClasses(data);
                        this.unblock();
                    });
                }).catch(error => {
                    MargettsApi.throwError(error);
                });
            }
        }
    }
</script>
